import ApplicationSerializer from 'volta/_pods/application/serializer';


export default class SimulationTaskSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    if (key === 'tasks') {
      return 'simulation-task';
    }
    return super.modelNameFromPayloadKey(key);
  }
}
